import { useAppDispatch } from "@/shared/lib/redux"
import { closeCreatePartnerDiscountModal, closeDeletePartnerDiscountModal, closeUpdatePartnerDiscountModal, openCreatePartnerDiscountModal, openDeletePartnerDiscountModal, openUpdatePartnerDiscountModal } from '../../model'
import { IPartnerDiscount } from "@/shared/api/partners"

export const useUpdatePartnerDiscountModals = () => {
    const dispatch = useAppDispatch()

    const openCreateDiscountModal = (onSuccess?: () => void) => {
        dispatch(openCreatePartnerDiscountModal({
            onSuccess
        }))
    }

    const openDeleteDiscountModal = (data: IPartnerDiscount, onSuccess?: () => void) => {
        dispatch(openDeletePartnerDiscountModal({
            data,
            onSuccess
        }))
    }

    const openUpdateDiscountModal = (data: IPartnerDiscount, onSuccess?: () => void) => {
        dispatch(openUpdatePartnerDiscountModal({
            data,
            onSuccess
        }))
    }

    const closeUpdateDiscountModal = () => {
        dispatch(closeUpdatePartnerDiscountModal())
    }

    const closeDeleteDiscountModal = () => {
        dispatch(closeDeletePartnerDiscountModal())
    }

    const closeCreateDiscountModal = () => {
        dispatch(closeCreatePartnerDiscountModal())
    }
    
    return {
        closeCreateDiscountModal,
        closeUpdateDiscountModal,
        closeDeleteDiscountModal,
        openCreateDiscountModal,
        openDeleteDiscountModal,
        openUpdateDiscountModal
    }
}